export default {
  网站名称: "樱花动漫",
  首页: "首页",
  分类: "分类",
  关于我们: "关于我们",
  搜索: "搜索",
  登录: "登录",
  注册: "注册",
  开始免费观看: "开始免费观看",
  立即播放: "立即播放",
  联系我们: "联系我们",
  了解更多: "了解更多",
  查看全部: "查看全部",
  加载更多: "加载更多",
  暂无数据: "暂无数据",
  返回首页: "返回首页",
  面包屑首页: "首页",
  版权信息: "© 2026 樱花动漫网 版权所有",
  快速链接: "快速链接",
  热门分类: "热门分类",
  关注我们: "关注我们",
  帮助中心: "帮助中心",
  关于品牌: "关于品牌",
  用户协议: "用户协议",
  隐私政策: "隐私政策",
  免责声明: "免责声明",
  商务合作: "商务合作",
  意见反馈: "意见反馈",
  追番指南: "追番指南",
  常见问题: "常见问题",
  联系客服: "联系客服",
  新浪微博: "新浪微博",
  微信公众号: "微信公众号",
  B站: "B站",
  抖音: "抖音",
} as Record<string, string>;